import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@anduin/auth';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false,
})
export class LogoutComponent implements OnDestroy {
  private _unsubscribe$ = new Subject<void>();

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {
    this.authService.logOutSSOUser().pipe(take(1), takeUntil(this._unsubscribe$)).subscribe();
  }

  login() {
    this.router.navigateByUrl('/login');
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
